import React, { useState } from 'react';
import { CloudIcon, Menu, X } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-100" data-id="element-157">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <div className="flex justify-between items-center h-16" data-id="element-159">
          <div className="flex items-center gap-2" data-id="element-160">
            <div className="bg-blue-600 p-1.5 rounded-lg" data-id="element-161">
              <CloudIcon className="w-6 h-6 text-white" data-id="element-162" />
            </div>
            <span className="text-xl font-bold text-slate-900 tracking-tight" data-id="element-163">
              BizCloud<span className="text-blue-600" data-id="element-164">Desk</span>
            </span>
          </div>

          <nav className="hidden md:flex items-center gap-8" data-id="element-165">
            <button onClick={() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })} className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors" data-id="element-166">
              Home
            </button>
            <button onClick={() => scrollToSection('early-access')} className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors" data-id="element-167">
              Early Access
            </button>
            <button onClick={() => scrollToSection('services')} className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors" data-id="element-168">
              Services Preview
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors" data-id="element-169">
              Contact
            </button>
          </nav>

          <div className="md:hidden" data-id="element-170">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="p-2 text-slate-600 hover:text-blue-600 transition-colors" aria-label="Toggle menu" data-id="element-171">
              {isMenuOpen ? <X className="w-6 h-6" data-id="element-172" /> : <Menu className="w-6 h-6" data-id="element-173" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-white border-b border-slate-100 animate-in slide-in-from-top duration-200" data-id="element-174">
          <nav className="flex flex-col p-4 space-y-4" data-id="element-175">
            <button onClick={() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          setIsMenuOpen(false);
        }} className="text-left text-base font-medium text-slate-600 hover:text-blue-600 transition-colors" data-id="element-176">
              Home
            </button>
            <button onClick={() => scrollToSection('early-access')} className="text-left text-base font-medium text-slate-600 hover:text-blue-600 transition-colors" data-id="element-177">
              Early Access
            </button>
            <button onClick={() => scrollToSection('services')} className="text-left text-base font-medium text-slate-600 hover:text-blue-600 transition-colors" data-id="element-178">
              Services Preview
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-left text-base font-medium text-slate-600 hover:text-blue-600 transition-colors" data-id="element-179">
              Contact
            </button>
          </nav>
        </div>}
    </header>;
}